import { render } from "./FeaturesIn.vue?vue&type=template&id=707d03d8"
import script from "./FeaturesIn.vue?vue&type=script&lang=js"
export * from "./FeaturesIn.vue?vue&type=script&lang=js"

import "./FeaturesIn.vue?vue&type=style&index=0&id=707d03d8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__